import React from 'react';
import { CheckmarkerIcon } from "../../../../ui/Icon";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import HeadingSmall from "../../../../ui/Typography/titles/HeadingSmall";
import styles from './OfferInformationData.module.scss';
const OfferInformationData = ({ offerInformation }) => {
    if (!offerInformation)
        return null;
    const { name, description, additionalDescription } = offerInformation;
    return (React.createElement("section", { className: styles.contentContainer },
        React.createElement("header", null,
            React.createElement(HeadingSmall, { Tag: "h2", className: styles.textMargin }, name),
            React.createElement(BodyText, { className: styles.textMargin }, description),
            React.createElement(MetaText, { className: styles.metaTextColor }, additionalDescription)),
        React.createElement(CheckmarkerIcon, { className: styles.checkIcon, "aria-hidden": "true" })));
};
export default OfferInformationData;
//# sourceMappingURL=OfferInformationData.js.map